export type StatusTone = 'ready' | 'awaiting' | 'expired'

export interface StatusChipProps {
  tone: StatusTone
  label: string
  className?: string
}

/**
 * Status chip backed by the shared `status.*` token triplets
 * (packages/tokens: ready / awaiting-signature / expired — all fg-on-bg
 * ≥ 4.5:1). Used for entitlement and agreement states across the portal.
 */
const toneClasses: Record<StatusTone, string> = {
  ready: 'border-status-ready-border bg-status-ready-bg text-status-ready-fg',
  awaiting: 'border-status-awaiting-border bg-status-awaiting-bg text-status-awaiting-fg',
  expired: 'border-status-expired-border bg-status-expired-bg text-status-expired-fg',
}

export function StatusChip({ tone, label, className = '' }: StatusChipProps) {
  return (
    <span
      className={`inline-flex items-center rounded-chip border px-3 py-1 text-small font-medium ${toneClasses[tone]} ${className}`}
    >
      {label}
    </span>
  )
}
